import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from './global.service';
import { map, catchError } from 'rxjs/operators'
import { environment } from 'src/environments/environment';
import { Observable } from "rxjs";

const devUrl = environment.backendurl;

export interface TestEmailData {
  recipient: string[];
  subject: string;
  body: string;
  replacements?: Record<string, any>;
}

@Injectable({
  providedIn: 'root'
})
export class EmailsettingsService {

  constructor(private http: HttpClient) { }

  //get Email  Tempalte
  getallEmailTemplate(userid) {
    let url = devUrl + "/template/getalltemplates/"+userid
    return this.http.get(url).pipe(
      map(response => { return response; })
      , catchError(GlobalService.handleError('get Email  Tempalte  ', url)))
  }


  getEmailDetails(id,usernumber) {
    let url = devUrl + "/template/getsingletemplate?usernumber=" +usernumber +"&templateid=" + id;
    return this.http.get(url).pipe(
      map(response => { return response }),
      catchError(GlobalService.handleError('Failed get email settings', url))
    )
  }


  //update email
  updateEmailList(data) {
    let url = devUrl + "/template/updatetemplate";
    return this.http.post(url, data).pipe(
      map(response => { return response }),
      catchError(GlobalService.handleError('Falied update email settings', url))
    )
  }

  //createcustomtemplate
  createCustomEmail(data) {
    let url = devUrl + "/template/createtemplate";
    return this.http.post(url, data).pipe(
      map(response => { return response }),
      catchError(GlobalService.handleError('Falied update email settings', url))
    )
  }

  sendbulkemail(data){
    let url = devUrl +"/candidate/bulkemailer";
    return this.http.post(url, data).pipe(
      map(response => { return response }),
      catchError(GlobalService.handleError('FAiled to send email', url))
    )
}

uploadDocument(data){
  let formData: FormData = new FormData();
  formData.append('text', 'resume');
  formData.append('resume', data);
  var url =devUrl + "/uploaddocument";
  return this.http.post(url, formData).pipe(map(response => { return response; })
    , catchError(GlobalService.handleError('Document Upload', url)));
}

  /**
   * Sends a test email using the provided data.
   * @param data The data for the test email.
   * @returns An Observable that emits the response from the server.
   */
  public sendTestEmail(data: TestEmailData): Observable<any> {
    let url = devUrl + "/test-email/send";
    return this.http.post(url, data).pipe(
      map(response => { return response }),
      catchError(GlobalService.handleError('Failed to send test email', url))
    )
  }

}
